<template>
  <div>
    <div v-if="renderMsgError">Não foi recebido o id do cliente</div>
  </div>
</template>

<script>
import DadosSessaoService from '@/services/DadosSessaoService'
import { insert, get, expires } from '@/uteis/localStorage'

export default {
  name: 'home',

  data () {
    return {
      renderMsgError: false
    }
  },

  async created () {
    await expires()
    const clientId = await get('client_id')
    if (this.$route.query.client_id) {
      await insert('client_id', this.$route.query.client_id, 1000 * 60 * 18)
    }

    if (this.$route.query.client_id || clientId) {
      this.renderMsgError = false
      new DadosSessaoService().buscarDadosSessao(this.$route.query.client_id || clientId).then(res => {
        this.$store.commit('MUT_DADOS_SESSAO', res.data[0])
        this.$router.push({ path: 'workArea' })
      }).catch(err => {
        console.log(err)
      })
    } else {
      this.renderMsgError = true
    }
  }
}
</script>

<style scoped>

</style>
